type ValueOf<T> = T[keyof T];

const roles = {
  admin: 'admin',
  manager: 'manager',
  operator: 'operator',
} as const;

export type RolesValues = ValueOf<typeof roles>;
export default Object.freeze(roles);
